import React, { useEffect } from 'react';
import Loader from 'src/components/Loader';
import NotesWithState from 'src/components/NotesNewWithState/NotesWithState';
import { useServiceRequestDataFromContext } from 'src/pages/ServiceRequest/Context/ServiceRequestContext';
import {
  useServiceRequestNotesActionsFromContext,
  useServiceRequestNotesDataFromContext,
} from 'src/pages/ServiceRequest/Context/ServiceRequestNotesContext';

const ServiceRequestNotes = () => {
  const { serviceRequest } = useServiceRequestDataFromContext();
  const { notes, loadingNotesDocs } = useServiceRequestNotesDataFromContext();
  const { saveNote, updateNote, deleteNote } =
    useServiceRequestNotesActionsFromContext();

  const handleSaveNote = async (note: any) => {
    await saveNote(note, serviceRequest.id);
  };

  const handleUpdateNote = async (note: any) => {
    await updateNote(note, serviceRequest.id);
  };

  const handleDeleteNote = async (noteToDelete: any) => {
    await deleteNote(noteToDelete, serviceRequest.id);
  };

  if (loadingNotesDocs) {
    return <Loader />;
  }

  return (
    <NotesWithState
      notes={notes}
      onSaveNote={handleSaveNote}
      onDeleteNote={handleDeleteNote}
      onEditNote={handleUpdateNote}
      breadcrumb={serviceRequest?.number}
      from="serviceRequests"
    />
  );
};

export default ServiceRequestNotes;
